<template>
  <div class="box">
    <div class="box-content" v-for="(item, index) in boxList" :key="index"
      v-show="(!item.is_co_main && !item.is_co_child) || detail.status >= 22 || item.is_current">
      <h6>
        <span v-if="item.is_co_main" style="color: #B4272D;"> 集运总单号：</span>
        <span v-if="item.is_co_child"> 集运副单号：</span>
        <span style="color: #B4272D;" v-if="item.is_main">
          父(需要报价的)
        </span>
        <span style="color: #B4272D;" v-if="item.is_child">
          子
        </span>
        <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" target="_blank" class="a-link">
          {{ item.porder_sn }}
        </router-link>
        <span v-if="item.is_current" style="color: #B4272D;">【当前配送单 】 </span>
        <!-- 合计体积 -->
        <span v-if="index == 0">
          <span class="totalVolume" v-for="(logistics) in logisticsTotalVolume"
            style="margin-right: 30px;color: #2c96e7;">
            {{ logistics.logistics_name }} {{ $t("message.totalVolume") }}m3: {{ logistics.totalVolume }}
          </span>
        </span>
      </h6>
      <div v-for="(items, indexs) in item.group" :key="indexs">
        <div class="head">
          <!--全选  -->
          <el-popover placement="right" width="100" trigger="focus">
            <p>勾选箱数统计:
              <span style="color: #B4272D;font-size: 18px">
                {{ boxIds.length }}
              </span>
            </p>
            <el-checkbox style="margin-right: 30px" v-model="items.checked" @change="allChecked(index, indexs)"
              slot="reference">{{ $t("message.allChecked") }}
            </el-checkbox>
          </el-popover>

          <!-- 装箱状态： -->
          <div class="item" v-if="status == 21">
            {{ $t("message.encasementStatus") }}: {{ items.statusName }}
          </div>
          <!-- 发送方式： -->
          <div class="item" v-else>
            {{ $t("message.wayToSend") }}: {{ items.logistics_name }}
          </div>
          <!--  合计重量.kg:-->
          <div class="item">
            {{ $t("message.totalWeight") }}.kg: {{ items.totalWeight }}
          </div>
          <!--  计费重量.kg:-->
          <div class="item" v-if="items.charged_weight">
            {{ $t("message.BillingWeight") }}.kg: {{ items.charged_weight }}
          </div>
          <!--  合计体积m3:-->
          <div class="item">
            {{ $t("message.totalVolume") }}m3: {{ items.totalVolume }}
          </div>
        </div>
        <!-- 箱子列表 -->
        <div class="box-list" :class="{ wuliuBox: status >= 50 }">
          <div class="item" v-for="box in items.list" :key="box.id" :class="{ isMax30: box.weight >= 30, }">
            <img src="@/assets/icon/cp.png" alt="" v-if="box.is_wooden">
            <el-popover placement="right" width="100" trigger="focus">
              <p>勾选箱数统计:
                <span style="color: #B4272D;font-size: 18px">
                  {{ boxIds.length }}
                </span>
              </p>
              <el-checkbox v-model="box.checked" @change="boxChecked" slot="reference"></el-checkbox>
            </el-popover>
            <div class="item-content" @click="lookBox(box.id, items.statusName)">
              <div class="row">
                <div class="label">NO:{{ box.number }}</div>
                <!-- 实重 -->
                <div class="value">
                  {{ $t("message.actualWeight") }}:{{ box.weight }}kg
                </div>
              </div>
              <div class="row">
                <div class="label">
                  {{ box.length }}*{{ box.width }}*{{ box.height }}
                </div>
              </div>
            </div>
            <!-- 填写物流单号 -->
            <div class="wuliu" v-if="status >= 50">
              <el-input v-model="box.express_no" @blur="updateExpressNo(box)" onfocus="this.select()"
                v-if="status == 50" @input="noJPtext(box.id)" @change="noJPtext(box.id, 'all')"></el-input>
              <!-- 国际物流 -->
              <div @click="logisticsTrack(box.express_no)" v-else>
                <el-popover placement="left" title="国际物流:" width="400" trigger="click">
                  <div v-if="activities != false" style="max-height: 600px; overflow-y: auto;">
                    <el-timeline>
                      <el-timeline-item v-for="(activity, index) in activities" :key="index" :timestamp="activity.time"
                        :color="activity.color" placement="top">
                        {{ activity.address }}
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                  <p v-else> 暂无物流信息 </p>
                  <p slot="reference">
                    <span class="WL">
                      <a href="javascript:;" class="a-link"> {{ box.express_no }}</a>
                    </span>
                  </p>
                </el-popover>
              </div>
              <!-- 跳转发票 -->
              <router-link v-if="status >= 50"
                :to="`/invoiceEdit?express_no=${box.express_no}&type=${items.logistics_name}`" target="_blank"
                class="invoice">
                <img src="@/assets/icon/invoice.png" alt="">
              </router-link>

              <!-- 打印面单 -->
              <div class="btn" @click="printedSheet(
                box.id,
                items.list.length,
                items.logistics_name,
                item.porder_sn,
                box.number,
                box.weight,
                box)">
                {{ $t("message.printedSheet") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    // boxList: { type: Array },
  },
  data() {
    return {
      checked: false,
      boxIds: [],
      selectBox: [],
      activities: [],
    };
  },
  computed: {
    ...mapState({
      boxList: (state) => state.porderDetail.boxList,
      status: (state) => state.porderDetail.status,
      detail: (state) => state.porderDetail.detail,
      logisticsTotalVolume: (state) => state.porderDetail.logisticsTotalVolume,
    }),
  },
  created() {
    this.$store.commit("setBoxIds", this.boxIds);
    this.$store.commit("setBox", this.selectBox);
  },
  methods: {
    // 全选
    allChecked(index, indexs) {
      this.boxIds = [];
      this.selectBox = [];
      this.boxList[index].group[indexs].list.forEach((box) => {
        box.checked = this.boxList[index].group[indexs].checked
      });
      this.boxList.forEach(item => {
        item.group.forEach(items => {
          items.list.forEach(box => {
            if (box.checked) {
              this.boxIds.push(box.id);
              this.selectBox.push(box.number);
            }
          })
        })
      })
      this.$store.commit("setBoxIds", this.boxIds);
      this.$store.commit("setBox", this.selectBox);
    },
    //单选
    boxChecked() {
      this.boxIds = [];
      this.selectBox = [];
      this.boxList.forEach((item) => {
        item.group.forEach((items) => {
          items.checked = items.list.every((box) => box.checked);
          items.list.forEach((box) => {
            if (box.checked) {
              this.boxIds.push(box.id);
              this.selectBox.push(box.number);
            }
          });
        });
      });
      this.$store.commit("setBoxIds", this.boxIds);
      this.$store.commit("setBox", this.selectBox);
    },
    //查看箱子详情
    lookBox(id, statusName) {
      this.$store.commit("setBoxStatus", statusName);
      this.$store.dispatch("boxDetail", { freight_id: id });
      this.$parent.$refs.movingGoodsBox.dialogVisible = true;
    },
    //修改物流单号
    updateExpressNo(box) {
      if (box.express_no == "" || box.express_no == null) return false;
      let datas = {
        express_no: box.express_no.replace(/\s*/g, ""),
        freight_id_set: [box.id],
      };

      this.$api.porderApi.updateExpressNo(datas).then((res) => {
        this.$message.success(res.msg);
      });
    },
    //面单打印
    printedSheet(id, boxTotal, logistics, Psn, num, weight, box) {
      this.logistics = logistics;
      this.$api.getMaitouData({ freightIds: [id], not_print: 1 }).then((res) => {
        res.data.forEach((item) => {
          item.boxTotal = boxTotal;
        });
        let datas = {
          logistics,
          printData: res.data,
          is_authorized: res.data[0].is_authorized,
        };
        this.$store.commit("setPrintData", datas);
        let department = "";
        // 寻找系统使用者的所在部门
        if (this.detail.department[0].indexOf("一部") != -1) {
          department = "一部";
        } else if (this.detail.department[0].indexOf("二部") != -1) {
          department = "二部";
        } else if (this.detail.department[0].indexOf("三部") != -1) {
          department = "三部";
        } else if (this.detail.department[0].indexOf("四部") != -1) {
          department = "四部";
        }
        let logisticsMethod = ""; //物流方式
        // 根据选择物流方式匹配对应的现实条件参数
        switch (logistics) {
          case "EMS船便":
            logisticsMethod = "ems";
            break;
          case "TW船便":
            logisticsMethod = "tw";
            break;
          case "OCS":
            logisticsMethod = "ocs";
            break;
          case "EMS":
            // 2023/6/30 我也不知道DQ是什么,先把emsAviation绑上去再说
            logisticsMethod = "emsAviation";
            break;
          default:
            logisticsMethod = logistics;
            break;
        }
        let psnLast4Str = "";
        if (Psn) {
          psnLast4Str = Psn.split("-")[0].substr(-4, Psn.length - 1);
        }
        console.log(this.selectBox);
        // url: type-显示类型,department-部门,sn-配送单号后四位+客户id,y_name-配送单业务员名称
        window.open(
          `/#/expressSinglePrint?type=${logisticsMethod}&department=${department}&sn=${psnLast4Str}-${this.detail.user_id}-${this.selectBox != false ? this.selectBox[0] : ''}-${num}&y_name=${this.detail.y_name}&weight=${weight}&length=${box.length}&width=${box.width}&height=${box.height}&p_username=${res.data[0].porder.p_admin.username}`,
          "_blank"
        );
        // if (logistics == "EMS") {
        //   this.$nextTick(() => {
        //     this.$print(this.$parent.$refs.EMSprintingmark);
        //   });
        // } else if (logistics == "TW") {
        //   this.$nextTick(() => {
        //     this.$print(this.$parent.$refs.TWCustomerShippingmark);
        //   });
        // } else if (logistics == "OCS") {
        //   this.$nextTick(() => {
        //     this.$print(this.$parent.$refs.OCSCustomerShippingmark);
        //   });
        // } else if (logistics == "DQ") {
        //   this.$nextTick(() => {
        //     this.$print(this.$parent.$refs.DQShippingmark);
        //   });
        // }
      });
    },
    noJPtext(id, text) {
      const halfWidth = /[\u0000-\u00FF]/
      this.boxList.forEach((item) => {
        item.group.forEach((items) => {
          items.checked = items.list.every((box) => box.checked);
          items.list.forEach((box) => {
            if (box.id == id) {
              if (!halfWidth.test(box.express_no)) {
                if (text) {
                  box.express_no = ''
                } else {
                  box.express_no = box.express_no.slice(0, -1); // 删除最后一个全角字符
                }

              }
            }
          });
        });
      });
    },
    // 跳转物流
    logisticsTrack(express_no) {
      let datas = {
        express_no
      }
      this.$api.logisticsTrack(datas).then(res => {
        if (res.data.address_data != false) {
          res.data.address_data[0].color = '#B4272D'
        }
        this.activities = res.data.address_data
      })
    },

  },
};
</script>
<style lang="scss" scoped>
.box {
  margin: 24px;
}

.box-content {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin-bottom: 1px solid #ededed;
}

h6 {
  font-size: 18px;
}

.head {
  display: flex;
  padding: 24px 12px;

  .item {
    margin-right: 48px;
  }
}

.box-list {
  display: flex;
  flex-wrap: wrap;

  .item {
    padding: 12px;
    background-color: #fff;
    margin-right: 12px;
    margin-bottom: 12px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;

    /deep/.el-checkbox {
      margin-right: 20px !important;
    }



    .item-content {
      .row {
        display: flex;
        margin-bottom: 5px;

        &:nth-last-child(1) {
          margin: 0;
        }

        .label {
          width: 60px;
        }
      }
    }

    .wuliu {
      display: flex;

      padding-left: 10px;
      position: relative;
      flex: 1;

      .el-input {
        width: 200px;
      }

      p {
        width: 212px;
        height: 40px;
        line-height: 40px;
      }

      .invoice {
        position: absolute;
        top: 0px;
        right: 120px;

        img {
          width: 40px;
        }
      }

      .btn {
        margin-left: 10px;
        height: 40px;
        width: 40px;
        background-color: #2c96e7;
        border-radius: 5px;
        padding: 0 10px;
        cursor: pointer;
        color: #fff;
        overflow: hidden;
        position: absolute;
        right: 10px;
        top: 0px;
      }
    }

    img {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 25px;
    }
  }

  .isMax30 {
    background-color: #fef0f0;
  }
}

.wuliuBox {
  .item {
    width: 540px;

    // &:nth-child(3n) {
    //   margin-right: 0 !important;
    // }
  }
}
</style>
